import $ from 'jquery';
import waypoints from '../../node_modules/waypoints/lib/noframework.waypoints';
import smoothScroll from 'jquery-smooth-scroll';

class StickyHeader {
    constructor() {
        this.lazyImages = $('.lazyload');
        this.siteHeader = $('.wrapper');
        this.headerTriggerElement = $('.sticky-trigger');
        this.logo = $('.logo');
        
        this.pageSections = $('.page-sections');
        this.headerLinks = $('.primary-nav a');

        this.createHeaderWaypoint();
        this.createPageSectionWaypoints();
        this.addSmoothScrolling();
        this.refreshWaypoints();
    }
    
    refreshWaypoints(){
        this.lazyImages.on('load', function(){
           Waypoint.refreshAll(); 
        });
    }
    
    addSmoothScrolling(){
        this.headerLinks.smoothScroll();
    }

    createHeaderWaypoint() {
        const that = this;
        new Waypoint({
            element: that.headerTriggerElement[0], //ez gecimenő, ide native JS DOM Elementet vár a waypoints és amit átadtunk az alapbol egy jQuery Object, de a jQuery object 1. eleme az mindig a native DOM Elementre pointer
            handler: function (direction) {
                if (direction == 'down') {
                    that.siteHeader.addClass('wrapper--dark');
                    that.logo.addClass('logo-s');
                } else {
                    that.siteHeader.removeClass('wrapper--dark');
                    that.logo.removeClass('logo-s');
                }
            }
        });
    }

    createPageSectionWaypoints() {
        const that = this;
        this.pageSections.each(function () {
            let currentPageSection = this;
            new Waypoint({
                element: currentPageSection,
                handler: function (direction) {
                    if (direction == 'down') {
                        let matchingHeaderLink = currentPageSection.getAttribute('data-matching-link');

                        that.headerLinks.removeClass('is-current-link');
                        $(matchingHeaderLink).addClass('is-current-link');
                    }
                },
                offset: '18%'
            });
            
            new Waypoint({
                element: currentPageSection,
                handler: function (direction) {
                    if (direction == 'up') {
                        let matchingHeaderLink = currentPageSection.getAttribute('data-matching-link');

                        that.headerLinks.removeClass('is-current-link');
                        $(matchingHeaderLink).addClass('is-current-link');
                    }
                },
                offset: '-20%'
            });
            
        });
    }

}

export default StickyHeader;
